import React from 'react';
// Helpers
import { withCDN } from 'helpers/cdn';
// Ui
import Image from 'ui/Image/Image';
// Components
import Divider from 'ui/Divider/Divider';

import styles from './OurProducts.module.scss';

const products = [
  {
    image: withCDN('/images/about-us/sell_merch.svg'),
    alt: 'your branded merchandise',
    title: 'BUILD YOUR BRAND & SELL YOUR MERCHANDISE',
    description:
      'Whether you have an existing line/brand or want us to help you develop a new collection, we make it easy. Launch new concepts as often as you want. No inventory. No billing hassles. Just launch and sell!',
  },
  {
    image: withCDN('/images/about-us/video_ama.svg'),
    alt: 'your "ask me anything videos"',
    title: 'Personal Videos',
    description:
      '​Let your fans request your insights via short form Personal Videos for event predictions, training tips, your story, or anything. Create viral content while generating more engagement with your current fans and new ones.',
  },
  {
    image: withCDN('/images/about-us/watch_stream.svg'),
    alt: 'you watch stream with fans',
    title: 'STREAM',
    description:
      'Let your fans watch events live with you via Stream. Broadcast to MILLIONS of fans at your own convenience. We automate the entire process end to end. All you do is set the price and start the broadcast.',
  },
];

export const OurProducts: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h3 className={styles.title}>OUR PRODUCTS</h3>
        <Divider className={styles.divider} />
        <ul className={styles.list}>
          {products.map(({ image, title, description, alt }) => (
            <li key={image} className={styles.listItem}>
              <div className={styles.imgWrapper}>
                <Image
                  src={image}
                  className={styles.img}
                  alt={alt}
                  loading="lazy"
                  unoptimized
                />
              </div>
              <div className={styles.product}>
                <h4 className={styles.productTitle}>{title}</h4>
                <Divider className={styles.productDivider} />
                <p className={styles.productDescription}>{description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
